import ls from 'local-storage'
import api from '../../api'

export default {
    state: {
        name: '',
        token: '',
        profile: '',
        feedsOrder: [],
        themesOrder: [],
    },
    mutations:{
        SET_USER: (state, user) => {
            state.name = user.name
            state.token = user.token
            ls('user', user)
            api.setToken(user.token)
            return user
        },
        SET_USER_PROFILE: (state, profile) => {
            state.profile = profile
            state.feedsOrder = profile.feedsOrder
            state.themesOrder = profile.themesOrder
        },
        CLEAR_USER: (state) => {
            state.name = ''
            state.token = ''
            ls('user', '')
            api.setToken('')
        },
        SET_ORDER_FEEDS: (state, feeds_id) => {
            state.feedsOrder = feeds_id
        }, 
        SET_ORDER_THEMES: (state, themes_id) => {
            state.themesOrder = themes_id
        }, 
        SET_LEARNED: (state) => {
            state.profile.learned = true
        },
    },
    actions: {
        async getProfile({ commit }) {
            try {
                const req = await api.get('/user/profile');
                commit('SET_USER_PROFILE', req.data.data)
            } catch (e) {
                throw 'не удалось войти в профиль пользователя'
            }
        },
        async logIn({ commit }, user) {
            try {
                const req = await api.post('/auth/login', { username: user.email, password: user.password });
                const token = req.data.token
                if (!token) {
                    throw "cannot get token"
                }                                   
                commit('SET_USER', {name: req.data.user.username, token})                
                return true;
            }
            catch (e) {
                commit('CLEAR_USER')
                throw 'неверный логин или пароль'
            }
        },
        async restorePassword({ commit }, user) {
            try {
                const req = await api.post('/auth/restore', { username: user.email });
                return true
            }
            catch (e) {
                throw e
            }
        },
        async signUp({ commit }, user) {
            try {
                const req = await api.post('/auth/register', { username: user.email, ...user })
                return req.data.data.user
            }
            catch (e) {
                throw e
            }
        },
        async repeatSignUp({ commit }, user) {
            try {
                const req = await api.post('/auth/resend', { username: user.email})
                return true
            }
            catch (e) {
                throw e
            }
        },
        logOut({ commit }) {
            commit('CLEAR_USER')
            commit('CLEAR_FEEDS')
            commit('CLEAR_THEMES')
            commit('CLEAR_CURRENT')
        },
        checkAuth({ commit }){
            const user = ls('user')
            if(user && user.token)
                return commit('SET_USER', user)            
        },
        async subscribe({ commit }, data) {
            try {
                const req = await api.put('/user/', { attr: 'subscription', value: JSON.stringify(data) })
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось подписаться')
                throw e
            } 
        }, 
        async activate({ commit }, data) {
            try {
                const req = await api.post('/auth/activate', { token: data.token })
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось подписаться')
                throw e
            } 
        }, 
    }
}